const authMiddleware = store => next => action => {
  return next(action)
/*
  switch (action.type) {
    case "emailSignUp": {
      var {email, password, chatToken} = action.signUp
      next(action)

      return emailSignUp(email, password, next, chatToken)
    }
    case "emailSignIn": {
      var {email, password} = action.signIn

      next(action)

      return emailSignIn(email, password, next)
    }
    case "initFacebookSignUp": {
      var {chatToken} = action.signUp

      next(action)
      return initFacebookSignUp(next, chatToken)

    }
    case "initFacebookSignIn": {

      next(action)
      return initFacebookSignIn(next)

    }
    default:
      return next(action)
  }
*/
}

export default authMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/auth/index.js